import {
  CheckCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled
} from "@/icons"
import cn from "classnames"
import styles from "./IntegrationStatusIcon.module.scss"
import type { IntegrationStatusIconProps } from "./IntegrationStatusIcon.types"

export const IntegrationStatusIcon = ({
  integrationStatus,
  variant
}: IntegrationStatusIconProps) => {
  const commonClassNames = cn(styles.statusIcon, {
    [styles.statusIconXl]: variant === "xl"
  })

  if (integrationStatus === "REQUESTED")
    return (
      <ClockCircleFilled className={cn(commonClassNames, styles.requested)} />
    )
  if (integrationStatus === "ERROR")
    return <CloseCircleFilled className={cn(commonClassNames, styles.error)} />

  return <CheckCircleFilled className={cn(commonClassNames, styles.success)} />
}
